<template>
  <!-- ページトップボタン -->
  <div class="l-pagetop" @click="imageClick($event)">
    <a href="#pagetop"></a>
  </div>
  <!-- /ページトップボタン -->
</template>

<script>
export default {
  data: function () {
    return {
      btn: null,
    }
  },
  mounted: function () {
    this.btn = $('.l-pagetop a');
  },
  methods: {
    imageClick: function(event){
      event.preventDefault();
      $('html, body').stop().animate({ scrollTop: 0 }, 500, 'swing');
    },
  }
};
</script>